import {
  history,
  redo,
  redoDepth,
  undo,
  undoDepth,
} from "@codemirror/commands";
import type { EditorView } from "@codemirror/view";
import React, { useEffect } from "react";
import { OverlayTrigger } from "react-bootstrap";

import { RedoIcon, UndoIcon } from "../icons";
import { renderTooltip } from "../StyledTooltip/StyledTooltip";

interface HistoryControlsProps {
  viewRef: React.MutableRefObject<EditorView | undefined>;
}

export const HistoryControls: React.FC<HistoryControlsProps> = ({
  viewRef,
}) => {
  const handleUndo = () => {
    if (viewRef.current) {
      undo({
        state: viewRef.current.state,
        dispatch: viewRef.current.dispatch,
      });
    }
  };

  const handleRedo = () => {
    if (viewRef.current) {
      redo({
        state: viewRef.current.state,
        dispatch: viewRef.current.dispatch,
      });
    }
  };
  const disableUndo = viewRef.current?.state
    ? undoDepth(viewRef.current.state) === 0
    : true;
  const disableRedo = viewRef.current?.state
    ? redoDepth(viewRef.current.state) === 0
    : true;

  return (
    <div className="editor-toolbar editor-toolbar-json">
      <div className="d-flex align-items-center">
        <OverlayTrigger
          placement="top"
          overlay={renderTooltip(<span>Undo</span>)}
        >
          <span>
            <button
              className="editor-toolbar__button editor-toolbar__button--history"
              onClick={handleUndo}
              disabled={disableUndo}
            >
              <UndoIcon />
            </button>
          </span>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={renderTooltip(<span>Redo</span>)}
        >
          <span>
            <button
              className="editor-toolbar__button editor-toolbar__button--history"
              onClick={handleRedo}
              disabled={disableRedo}
            >
              <RedoIcon />
            </button>
          </span>
        </OverlayTrigger>
      </div>
    </div>
  );
};
